export default "__VITE_ASSET__DamFy6xj__"